import { snakeToCapitalized } from '../../lib/stringHelpers';
import { store } from '../../store';
import { orderService } from '../../services';
import { REFUND_OPTION_TYPES } from '../../constants/refundOptions';

const hasReturnReason = (condition) =>
  orderService
    .getItems()
    .map((e) => e?.return_desc?.toLowerCase().includes(condition))
    .some(Boolean);

const getResolutions = (resolutions) =>
  resolutions.filter((resolution) => {
    if (!resolution.conditions || resolution.conditions.length === 0) {
      return Boolean(resolution.root);
    }

    return resolution.conditions.every((condition) => {
      if (condition.type === 'returnReason') {
        return condition.includes.some((val) => hasReturnReason(val));
      }
      return Boolean(resolution.root);
    });
  });

export const mapStaticRefund = (options) =>
  options.map((option) => ({
    ...option,
    id: `${option.key}.${option.value}`,
    value: option.value,
    title: {
      content: snakeToCapitalized(option.value),
      langKey: `returns.step_3.${option.nameToken || option.value}.title`,
    },
    description: {
      content: option.text,
      langKey: `returns.step_3.${option.nameToken || option.value}.text`,
    },
  }));

export const mapDynamicRefund = (options) =>
  options.map((option) => ({
    ...option,
    id: option.name_token,
    value: option.type,
    title: null,
    description: {
      content: option.refund_message,
      langKey: `returns.step_3.${option.name_token}.text`,
    },
  }));

const getExtraOptions = ({ optionSource, type, flag }) => {
  let options = [];

  if (flag === 'refundOptionChildren') {
    if (type === REFUND_OPTION_TYPES.STATIC) {
      const refundOptionSettings = optionSource.refundOptionSettings || {};
      options = mapStaticRefund(refundOptionSettings.options || []);
    } else if (type === REFUND_OPTION_TYPES.ESTIMATE) {
      const { refunds: { estimate: { methods = [] } = {} } = {} } = store.getState();
      options = mapDynamicRefund(methods);
    }
  }

  return options;
};

const attachExtraOptions = (resolution, extraOptions) => ({
  ...resolution,
  children: {
    nodes: extraOptions.map((option) => option.id),
    header: { langKey: `returns.step_3.${resolution.id}_label` },
  },
});

export const getResolutionOptions = ({ optionSource, resolutionsConfig = [], type }) => {
  const validResolutions = getResolutions(resolutionsConfig);
  let allExtraOptions = [];
  const updatedResolutions = validResolutions
    .map((resolution) => {
      const customFlags = resolution?.customFlags || {};
      return Object.entries(customFlags).reduce((res, [flag, isActive]) => {
        let updatedResolution = res;
        if (isActive) {
          const extraOptions = getExtraOptions({ optionSource, type, flag });
          if (extraOptions.length > 0) {
            allExtraOptions = [...allExtraOptions, ...extraOptions];
            updatedResolution = attachExtraOptions(resolution, extraOptions, flag);
          }
        }
        return updatedResolution;
      }, resolution);
    })
    .filter(Boolean);
  return [...updatedResolutions, ...allExtraOptions];
};
